import { render } from "./FullUserList.vue?vue&type=template&id=2d492494"
import script from "./FullUserList.vue?vue&type=script&lang=js"
export * from "./FullUserList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__